import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDeleteComponent } from '../../../components/confirm-delete/confirm-delete.component';
import { CourseInformationFormComponent } from '../../../components/course-information-form/course-information-form.component';
import { ImagePreviewComponent } from '../../../components/image-preview/image-preview.component';

import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-course-detail',
  standalone: true,
  imports: [
    CommonModule,
    LoaderComponent,
    CourseInformationFormComponent,
    NgbDropdownModule,
    CdkDropList,
    CdkDrag
  ],
  templateUrl: './course-detail.component.html',
  styleUrl: './course-detail.component.scss'
})
export class CourseDetailComponent {
  loading: boolean = false;
  item: any | null = null;
  sections: any[] | null = null;
  activeSection: any | null = null;
  currentItemId: string = '';

  @ViewChild('fileInput') fileInput: ElementRef | null = null;
  courseImage?: Blob | any;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService
  ) {
    this.loading = true;
    this.getItem();
    this.getSections();
    this.getCourseImage();
  }

  getItem() {
    let itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/courses/' + itemId).then(function (response: any) {
      self.item = response;
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }


  removeImage() {
    let self = this;

    self.loading = false;
    const deleteModal = this.modalService.open(ConfirmDeleteComponent);
    deleteModal.componentInstance.message = 'Weet je zeker dat je de afbeelding wilt verwijderen?';
    deleteModal.result.then((result): any => {
      if (result) {
        let self = this;
        return this.apiService.delete('/office/courses/' + self.item['id'] + '/image').then(function (response: any) {
          self.getItem();
          self.courseImage = null;
        });
      } else {
        return true;
      }
    });
  }

  triggerFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadImage(this.item, file);
    }
  }

  uploadImage(item: any, file: any) {
    let self = this;
    return this.apiService.post('/office/courses/' + item['id'] + '/image', {
      file: file
    }).then(function (response: any) {
      self.sync();
    });
  }

  updateImagePosition(item: any, position: number) {
    return this.apiService.put('/office/courses/image/' + item['id'], {
      position: position
    });
  }

  openImagePreview(imageId: string) {
    const previewModal = this.modalService.open(ImagePreviewComponent, {
      size: 'xl',
    });
    previewModal.componentInstance.imageUrl = imageId;
    previewModal.result.then((result): any => {
    });
  }

  courseIdToUrl(id: string) {
    return this.apiService.getApiBaseURL() + '/office/courses/' + this.item['id'] + '/image/' + id + '/view';
  }

  setActiveSection(section: []) {
    this.activeSection = section;
  }

  viewCourse() {
    this.router.navigate(['/course/list']);
  }

  delete(item: any) {
    let self = this;
    self.loading = false;
    const deleteModal = this.modalService.open(ConfirmDeleteComponent);
    deleteModal.componentInstance.message = 'Weet je zeker dat je wilt verwijderen?';
    deleteModal.result.then((result) => {
      if (result) {
        let self = this;
        return this.apiService.delete('/office/courses/' + item['id']).then(function (response: any) {
          self.router.navigate(['/course/list']);
          return true;
        }).catch(function (e) {
          self.router.navigate(['/course/list']);
        });
      } else {
        return true;
      }
    });
  }

  sync() {
    let self = this;
    self.loading = true;

    return this.apiService.get('/office/courses/' + self.item['id'] + '/sync').then(function (response: any) {
      self.getItem();
      self.getSections();
      self.getCourseImage();

      setTimeout(function () {
        self.loading = false;
      }, 300);
    }).catch(function (e) {
      self.getItem();
      self.getSections();
      self.getCourseImage();

      setTimeout(function () {
        self.loading = false;
      }, 300);
    });
  }

  openModal(content: TemplateRef<any>, itemId: any) {
    let self = this;

    if (itemId) {
      self.currentItemId = itemId;
    } else {
      self.currentItemId = '';
    }

    this.modalService.open(content, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title'
    }).result.then(
      (result) => {
        self.getItem();
        self.getSections();
      },
      (reason) => {
        self.getItem();
        self.getSections();
      },
    );
  }

  getSections() {
    let itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.get('/office/courses/' + itemId + '/sections').then(function (response: any) {
      self.sections = response;
      if (!self.activeSection && self.sections) {
        self.sections.forEach(item => {
          if (!self.activeSection) {
            self.activeSection = item;
          }
          return true;
        });
      }
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  getCourseImage() {
    let itemId = this.activatedRoute.snapshot.paramMap.get('id');
    let self = this;
    return this.apiService.getImage('/office/courses/' + itemId + '/image/view').then(function (response: any) {
      self.courseImage = URL.createObjectURL(response);
    }).catch(function (e) {
      console.log(e)
    });
  }
}
